import * as React from 'react'
import * as ReactDOM from 'react-dom'
import OtherDonateItem from '../otherDonatedItem'

class OtherDonate extends React.Component {

    constructor(props) {
        super(props)
        let {title,data} = props.data;
        let dataLength = data.length;
        let actions = Array.apply(null, Array(dataLength)).map(Number.prototype.valueOf,0);
        this.state = {
            title : title,
            data  : data,
            action: actions
        }
    }

    handleClickTab = (value) =>{
        let actions = this.state.action;
        actions.forEach((item,index) => {
            value != index ? actions[index]=0 : '';
            
        })
        actions[value] == 1 ? actions[value] = 0 : actions[value] = 1
        this.setState({
            action : actions
        })
    }

    render() {
        let listOtherItem = this.state.data
        const RENDER_HTML_OTHER_DONATED_ITEM =  listOtherItem.map((item, index) => {
            let {_id} = item
            return (
                <OtherDonateItem 
                index={index}
                isOpen={this.state.action[index]}
                key={`other-donatded-${index}-${_id}`} 
                data={item} 
                handleClickTab={this.handleClickTab}
                />
            )
        })

        return (
            <div className="other-donated">
                <div className="other-donated__container container">
                    <div className="row">
                        <div className="col-md-2 col-12"></div>
                        <div className="col-md-8 col-12">
                            <h3 className="other-donated__title">
                                {this.state.title}
                            </h3>
                            <div className="other-donated__list">
                                {RENDER_HTML_OTHER_DONATED_ITEM}
                            </div>
                        </div>
                        <div className="col-md-2 col-12"></div>
                    </div>
                </div>
            </div>
        )
    }
}   

export default OtherDonate;